import { selector, selectorFamily } from 'recoil';
import { DocSubTypeEnum } from '@zurich/api/party';
import { createFieldValidationSelector, validateSchema, } from '@zurich/common/recoil';
import { partyCountrySchema, partyDDocNumberBaseSchema, partyDiplomaticStatusSchema, partyDocumentdDocSinceSchema, partyDocumentdDocUntilSchema, partyDocumentExpiryDateRequiredSchema, partyDocumentExpiryDateSchema, partyDocumentIssueDateSchema, partyDocumentIssuingAuthoritySchema, partyDocumentMetadataDocSubTypeSchema, partyDocumentMetadataDriversLicenseNumberSchema, partyDocumentMetadataIdentityDocumentNumberSchema, partyModificationReasonSchema, } from '../../forms';
import { localModificationReason } from '../atoms';
import { localPartyDocumentMetadataCountryOfIssueSelector, localPartyDocumentMetadataDDocNumberSelector, localPartyDocumentMetadataDDocSinceSelector, localPartyDocumentMetadataDDocUntilSelector, localPartyDocumentMetadataDiplomaticStatusSelector, localPartyDocumentMetadataDocSubTypeSelector, localPartyDocumentMetadataDriversLicenseNumberSelector, localPartyDocumentMetadataExpiryDateSelector, localPartyDocumentMetadataIdentityDocumentNumberSelector, localPartyDocumentMetadataIssueDateSelector, localPartyDocumentMetadataIssuingAuthoritySelector, } from '../selectors/localDocument';
import { localPartyDateOfBirthSelector } from '../selectors/localParty';
const vehicleValidationHelper = createFieldValidationSelector('@zurich/party/validation/document');
export const localPartyDocumentMetadataDocSubTypeValidationSelector = vehicleValidationHelper('docSubType', localPartyDocumentMetadataDocSubTypeSelector, partyDocumentMetadataDocSubTypeSchema);
export const localPartyDocumentMetadataDriversLicenseNumberValidationSelector = vehicleValidationHelper('driversLicenseNumber', localPartyDocumentMetadataDriversLicenseNumberSelector, partyDocumentMetadataDriversLicenseNumberSchema);
export const localPartyDocumentMetadataIdentityDocumentNumberValidationSelector = vehicleValidationHelper('identityDocumentNumber', localPartyDocumentMetadataIdentityDocumentNumberSelector, partyDocumentMetadataIdentityDocumentNumberSchema);
export const localPartyDocumentMetadataDDocNumberValidationSelector = vehicleValidationHelper('dDocNumber', localPartyDocumentMetadataDDocNumberSelector, partyDDocNumberBaseSchema);
export const localPartyDocumentMetadataIssueDateValidationSelector = selector({
    key: '@zurich/party/local/validation/issueDate',
    get: ({ get }) => {
        const fromDate = get(localPartyDocumentMetadataIssueDateSelector);
        const dateOfBirth = get(localPartyDateOfBirthSelector);
        const toDate = get(localPartyDocumentMetadataExpiryDateSelector);
        return validateSchema(partyDocumentIssueDateSchema, {
            fromDate,
            toDate: toDate ?? '',
            dateOfBirth,
        });
    },
});
export const localPartyDocumentMetadataExpriryDateValidationSelector = selector({
    key: '@zurich/party/local/validation/expiryDate',
    get: ({ get }) => {
        const fromDate = get(localPartyDocumentMetadataIssueDateSelector);
        const toDate = get(localPartyDocumentMetadataExpiryDateSelector);
        const docSubType = get(localPartyDocumentMetadataDocSubTypeSelector);
        return validateSchema(docSubType === DocSubTypeEnum.FUEH
            ? partyDocumentExpiryDateSchema
            : partyDocumentExpiryDateRequiredSchema, {
            toDate,
            fromDate: fromDate ?? '',
        });
    },
});
export const localPartyDocumentMetadataDDocSinceValidationSelector = selectorFamily({
    key: '@zurich/party/local/validation/dDocSince',
    get: (dateOfBirth) => ({ get }) => {
        const fromDate = get(localPartyDocumentMetadataDDocSinceSelector);
        const toDate = get(localPartyDocumentMetadataDDocUntilSelector);
        return validateSchema(partyDocumentdDocSinceSchema, {
            fromDate,
            toDate: toDate ?? '',
            dateOfBirth,
        });
    },
});
export const localPartyDocumentMetadataDDocUntilValidationSelector = selector({
    key: '@zurich/party/local/validation/dDocUntil',
    get: ({ get }) => {
        const toDate = get(localPartyDocumentMetadataDDocUntilSelector);
        const fromDate = get(localPartyDocumentMetadataDDocSinceSelector);
        return validateSchema(partyDocumentdDocUntilSchema, {
            toDate,
            fromDate: fromDate ?? '',
        });
    },
});
export const localPartyDocumentMetadataCountryOfIssueValidationSelector = vehicleValidationHelper('countryOfIssue', localPartyDocumentMetadataCountryOfIssueSelector, partyCountrySchema);
export const localPartyDocumentMetadataIssuingAuthorityValidationSelector = vehicleValidationHelper('issuingAuthority', localPartyDocumentMetadataIssuingAuthoritySelector, partyDocumentIssuingAuthoritySchema);
export const localPartyDocumentMetadataDiplomaticStatusValidationSelector = vehicleValidationHelper('diplomaticStatus', localPartyDocumentMetadataDiplomaticStatusSelector, partyDiplomaticStatusSchema);
export const localPartyDocumentModificatioReasonValidationSelector = selector({
    key: '@zurich/party/local/validation/modificatioReason',
    get: ({ get }) => {
        const modificationReason = get(localModificationReason);
        return validateSchema(partyModificationReasonSchema, modificationReason);
    },
});
